import { Layout } from 'CorePackage/MainModule/components/Layout';

import { PublicFeedbackForm } from './PublicFeedbackForm';
import styles from './PublicFeedback.module.scss';

export const PublicFeedback = () => (
  <Layout>
    <div className="shared-content">
      <h3 className={styles.h3} id="feedbackForm">
        Форма обратной связи
      </h3>
      <PublicFeedbackForm />
      <div className={styles.FeedbackFormWrap}>
        <h3 className={styles.h3}>Работа с обращениями</h3>
        <div className={styles.ListDescLast}>
          Службой технической поддержки ФГИС &quot;Единый реестр контрольных (надзорных) мероприятий&quot; и ее
          подсистемы &quot;Единый реестр проверок&quot; обращения рассматриваются в течении трех рабочих дней с даты
          регистрации обращения.
        </div>
        Обращения принимаются:
        <ul className={styles.List}>
          <li>По форме обратной связи, расположенной выше (круглосуточно);</li>
          <li>По адресу электронной почты: erp_support@genproc.gov.ru (круглосуточно);</li>
          <li>
            <div className={styles.FlexBlock}>
              По номеру телефона
              <a className={styles.Phone} href="tel:8(800)100-35-38" rel="nofollow">
                8(800)100-35-38
              </a>
              (с 9 до 18:00 по московскому времени).
            </div>
          </li>
        </ul>
      </div>
    </div>
  </Layout>
);
